import { FC, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { LMTable } from "../../../components/LMTable";
import { ColumnType } from "antd/es/table";
import { getTranslation } from "../../i18n";
import { ProductPhotoCell } from "../../../components";
import { IOrderProduct } from "../types";
import { LMIconButton } from "../../../components/LMIconButton";
import { IconEdit } from "../../../assets/Sprites";
import styles from "./OrderProducts.module.css";
import { OrderQuantityChange } from "../OrderQuantityChange";

interface Props {
  orderProducts: IOrderProduct[];
  orderId: string;
}

export const OrderProducts: FC<Props> = ({ orderProducts, orderId }) => {
  const { t } = useTranslation("order");
  const [selectedProduct, setSelectedProduct] = useState<IOrderProduct | null>(
    null
  );

  const columns = useMemo(
    () => [
      {
        title: t("name"),
        key: "name",
        render: (orderProduct: IOrderProduct) => {
          return (
            <ProductPhotoCell
              name={getTranslation(orderProduct.product.name) || ""}
              image={orderProduct.product.primaryImageUrl}
            />
          );
        },
        sorter: true,
      },
      {
        title: t("identifier"),
        key: "identifier",
        render: (orderProduct: IOrderProduct) => {
          return (
            <div>
              {orderProduct.product.identifiers.map((identifier) => (
                <div key={identifier.value}>
                  {identifier.type}: {identifier.value}
                </div>
              ))}
            </div>
          );
        },
      },
      {
        title: t("quantity"),
        key: "quantity",
        dataIndex: "quantity",
      },
      {
        title: t("collectedQuantity"),
        key: "collectedQuantity",
        dataIndex: "collectedQuantity",
      },
      {
        title: t("returnedQuantity"),
        key: "returnedQuantity",
        render: (orderProduct: IOrderProduct) => {
          return (
            <div className={styles.action}>
              {orderProduct.returnedQuantity}
              <LMIconButton
                title={t("manuallyChangeReturnedQuantity")}
                onClick={() => setSelectedProduct(orderProduct)}
              >
                <IconEdit />
              </LMIconButton>
            </div>
          );
        },
      },
      {
        title: t("refundedQuantity"),
        key: "refundQuantity",
        dataIndex: "refundQuantity",
      },
    ],
    [t]
  ) as ColumnType<IOrderProduct>[];

  return (
    <div className={styles.container}>
      <LMTable
        columns={columns}
        dataSource={orderProducts}
        total={{ amount: orderProducts.length, title: t("totalProducts") }}
      />
      <OrderQuantityChange
        selectedProduct={selectedProduct}
        onClose={() => setSelectedProduct(null)}
        orderId={orderId}
      />
    </div>
  );
};
